import OfferSection from './OfferSection';

export default OfferSection;
